// extracted by mini-css-extract-plugin
module.exports = {"flatList":"coupon-section_flatList__kv7qQ","contentContainer":"coupon-section_contentContainer__pJd2Q"};